import React, { useState, useEffect } from 'react';
import { Container, Header, Segment, Divider, Button, Modal, Icon, Image } from 'semantic-ui-react';
import '@styles/BlogBody.css';
import '@styles/GeneralTheme.css';
import WebToLead from '@components/WebToLead';
import ServicesCalculator from '@components/ServicesCalculator';

const OurServices = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Add Open Graph meta tags for our services page
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    document.title = 'Services Calculator - Cloud CZR | Salesforce Development & Technology Consulting';
    updateMetaTag('og:title', 'Services Calculator - Cloud CZR | Salesforce Development & Technology Consulting');
    updateMetaTag('og:description', 'Calculate your Salesforce project costs with our interactive calculator. Compare prices with industry averages and get instant quotes.');
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'website');
    updateMetaTag('og:image', `${window.location.origin}/assets/CloudChiRho.png`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', 'Calculate your Salesforce project costs with our interactive calculator. Compare prices with industry averages and get instant quotes.', false);
    updateMetaTag('twitter:title', 'Services Calculator - Cloud CZR | Salesforce Development & Technology Consulting', false);
    updateMetaTag('twitter:description', 'Calculate your Salesforce project costs with our interactive calculator. Compare prices with industry averages and get instant quotes.', false);
  }, []);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <Container fluid style={{ marginTop: '2em', padding: isDesktop ? '0 2em' : '0 1em', maxWidth: 'none !important', width: '100% !important' }}>
      <Header as='h1' textAlign='center' style={{ color: '#a9885c' }}>
        <Image src={`${process.env.PUBLIC_URL}/assets/services.svg`} alt="Cloud CZR, Cloudczr, cloudczr.com" style={{ width: isDesktop ? '50%' : '100%', height: 'auto', margin: '0 auto 15px auto', display: 'block' }} />
      </Header>

      <div style={{ textAlign: 'center', marginBottom: '2em', maxWidth: '800px', marginLeft: 'auto', marginRight: 'auto' }}>
        <img 
          src="/assets/Performancemarketing.svg" 
          alt="Performance Marketing" 
          style={{ 
            width: '100%', 
            height: 'auto',
            backgroundColor: 'white',
            border: '2px solid #a9885c',
            borderRadius: '8px',
            padding: '1em'
          }}
        />
      </div>

      <ServicesCalculator />

      <Divider hidden />

      <Segment padded textAlign='center' style={{ width: '100%', maxWidth: 'none', backgroundColor: '#702963', border: '2px solid #a9885c' }}>
        <Header as='h2' icon='handshake outline' content="Ready to Get Started?" style={{ color: '#a9885c' }}/>
        <p className="body-gold" style={{ color: '#a9885c', fontSize: '1.2em', lineHeight: '1.6', marginBottom: '2em' }}>
          Let's discuss your project and create a customized solution that fits your needs and budget.
        </p>
        <Button primary size='huge' className="custom-button-body" onClick={handleOpenModal} style={{ backgroundColor: '#a9885c', color: '#702963', borderColor: '#a9885c' }}>
          <Icon name='envelope' />
          Get In Touch
        </Button>
      </Segment>

      {/* Contact Form Modal */}
      <Modal open={modalOpen} onClose={handleCloseModal} size='small' style={{ backgroundColor: '#702963' }}>
        <Modal.Header style={{ backgroundColor: '#702963', color: '#a9885c' }}>Contact Us</Modal.Header>
        <Modal.Content style={{ backgroundColor: '#a9885c' }}>
          <WebToLead />
        </Modal.Content>
        <Modal.Actions style={{ backgroundColor: '#702963', color: '#a9885c' }}>
          <Button style={{ backgroundColor: '#a9885c', color: '#702963' }} onClick={handleCloseModal}>Close</Button>
        </Modal.Actions>
      </Modal>
    </Container>
  );
};

export default OurServices;